import toast from "react-hot-toast";

const server = process.env.REACT_APP_SERVER_URL || "";

export const createFeature = {
  // Ajouter une fonctionnalité
  add: async (formData: any) => {
    try {
      const response = await fetch(`${server}/api/admin/features`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.msg);
        return data;
      } else {
        toast.error(data.error);
        throw new Error(data.error || response.statusText);
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout de la fonctionnalité:", error);
      throw error;
    }
  },

  // Récupérer toutes les fonctionnalités (activées)
  fetchFeatures: async () => {
    try {
      const response = await fetch(`${server}/api/features`);
      if (!response.ok) {
        throw new Error("Échec de la récupération des fonctionnalités");
      }
      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // Supprimer une fonctionnalité
  delete: async (id: number) => {
    try {
      const response = await fetch(`${server}/api/admin/features/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Une erreur s'est produite lors de la suppression.");
      }

      const res = await response.json();
      toast.success(res.message);
    } catch (error) {
      console.error("Erreur de suppression:", error);
      throw new Error("Erreur lors de la suppression de la fonctionnalité.");
    }
  },

  // Mettre à jour une fonctionnalité
  update: async (data: any, id: any) => {
    try {
      const { designation } = data;

      const response = await fetch(`${server}/api/admin/features/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify({ designation }),
      });

      if (response.ok) {
        const result = await response.json();
        return result;
      } else {
        throw new Error("Échec de la mise à jour de la fonctionnalité");
      }
    } catch (error) {
      console.error("Erreur de mise à jour:", error);
      throw error;
    }
  },

  // Récupérer une fonctionnalité par ID
  getById: async (id: number) => {
    try {
      const response = await fetch(`${server}/api/features/${id}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Échec de la récupération de la fonctionnalité");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },

  // Admin - récupérer toutes les fonctionnalités avec pagination et recherche
  adminGetAllFeatures: async (page = 1, searchTerm = "") => {
    const query = new URLSearchParams({ page: page.toString() });
    if (searchTerm) {
      query.append("searchTerm", searchTerm);
    }

    const response = await fetch(`${server}/api/admin/features?${query.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    if (!response.ok) {
      throw new Error("Échec de la récupération des fonctionnalités administrateur");
    }

    return await response.json();
  },
};
